import styled from 'styled-components'

export const PageLimitStyled = styled.div`
  display: flex;
  align-items: center;
`
